import { ReactNode, useEffect } from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from '../../branding/BrandLogo';
import { getBrand } from '../../branding/brand';
import LegalLinks from '../../components/legal/LegalLinks';
import { APP_ROUTES } from '../../utils/constants/appRoutes';
import '../../components/auth/style.css';
import './legal.css';

interface LegalPageLayoutProps {
  title: string;
  subtitle: string;
  effectiveDate: string;
  lastUpdated: string;
  children: ReactNode;
}

const LegalPageLayout = ({
  title,
  subtitle,
  effectiveDate,
  lastUpdated,
  children,
}: LegalPageLayoutProps) => {
  const documentTitle = getBrand().documentTitle;

  useEffect(() => {
    const previous = document.title;
    document.title = `${title} | ${documentTitle}`;
    document.documentElement.classList.add('legal-page-open');
    document.body.classList.add('legal-page-open');
    return () => {
      document.title = previous;
      document.documentElement.classList.remove('legal-page-open');
      document.body.classList.remove('legal-page-open');
    };
  }, [documentTitle, title]);

  return (
    <div className="limiter limiter-legal">
      <div className="container-login100 container-legal">
        <div className="wrap-login100 wrap-legal">
          <Link to={APP_ROUTES.AUTH} className="legal-logo-link">
            <BrandLogo />
          </Link>
          <h1 className="legal-title">{title}</h1>
          <p className="legal-subtitle">{subtitle}</p>
          <p className="legal-dates">
            Effective Date: {effectiveDate}
            {' · '}
            Last Updated: {lastUpdated}
          </p>
          <article className="legal-article">{children}</article>
          <nav className="legal-footer-nav" aria-label="Legal documents">
            <LegalLinks />
            <div className="auth-nav-link">
              <Link to={APP_ROUTES.AUTH}>Return to Sign In</Link>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default LegalPageLayout;
